import { render, staticRenderFns } from "./PortfolioV2.vue?vue&type=template&id=c8b27fdc&scoped=true&"
import script from "./PortfolioV2.vue?vue&type=script&lang=js&"
export * from "./PortfolioV2.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioV2.vue?vue&type=style&index=0&id=c8b27fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b27fdc",
  null
  
)

export default component.exports